import { ONFIDO_JS_BUNDLE } from 'constants/Onfido';

export const addScript = (filepath, callback) => {
    if (filepath) {
        const fileref = document.createElement('script');
        let done = false;
        const head = document.getElementsByTagName('head')[0];

        if (callback) {
            fileref.onload = fileref.onreadystatechange = function () {
                if (!done && (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete')) {
                    done = true;
                    callback();
                    // Handle memory leak in IE
                    fileref.onload = fileref.onreadystatechange = null;
                    if (head && fileref.parentNode) {
                        head.removeChild(fileref);
                    }
                }
            };
        }

        fileref.setAttribute('type', 'text/javascript');
        fileref.setAttribute('src', filepath);

        head.appendChild(fileref);
    }
};

export const addOnfido = (callback) => {
    addScript(ONFIDO_JS_BUNDLE, callback);
};

export const addStyleLink = (linkPath) => {
    const linkElement = document.createElement('link');
    linkElement.setAttribute('rel', 'stylesheet');
    linkElement.setAttribute('href', linkPath);
    const head = document.getElementsByTagName('head')[0];
    head.appendChild(linkElement);
};
export const removeScript = (scriptPath) => {
    let scripts = document.getElementsByTagName('script');
    for (let i = scripts.length; i >= 0; i--) {
        if (scripts[i] && scripts[i].getAttribute('src') !== null && scripts[i].getAttribute('src').indexOf(`${scriptPath}`) !== -1) {
            scripts[i].parentNode.removeChild(scripts[i]);
        }
    }
};

export const removeLink = (linkPath) => {
    let links = document.getElementsByTagName('link');
    for (let i = links.length; i >= 0; i--) {
        if (links[i] && links[i].getAttribute('href') !== null && links[i].getAttribute('href').search(new RegExp(`${linkPath}`)) !== -1) {
            links[i].remove();
        }
    }
};

export const addMetaTag = (name, content) => {
    const meta = document.createElement('meta');
    meta.content = content;
    meta.name = name;
    document.getElementsByTagName('head')[0].appendChild(meta);
};
